<ng-container *transloco="let t">
  <mat-chip
    class="chip font-semibold!"
    [class]="`chip--${color()}`"
    [class.chip--static]="!this.clickable()"
    [disableRipple]="!clickable()"
    [disabled]="disabled()"
    (click)="clickable() ? clickOutput.emit() : null"
  >
    @if (prefixSvgIcon()) {
    <mat-icon matChipAvatar [svgIcon]="prefixSvgIcon()!"></mat-icon>
    }
    {{ isKeyTranslated() ? translatedLabel().key : t(translatedLabel().key, translatedLabel().params) }}
    @if (suffixSvgIcon()) {
    <div matChipTrailingIcon>
      <mat-icon [svgIcon]="suffixSvgIcon()!"></mat-icon>
    </div>
    }
  </mat-chip>
</ng-container>
